import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import Link from 'Root/Component/Link'

import styles from '../index.module.css'

interface Props {
  id: string
}

library.add(faPencil)

const Edit = ({ id }: Props) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <Link
          to={`/collections/${id}/edit`}
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item,
            'group'
          )}
        >
          <FontAwesomeIcon className={styles.icon} icon={['fas', 'pencil']} />
          <Trans>Modifica Corso</Trans>
        </Link>
      )}
    </Menu.Item>
  )
}

export default Edit
